export const PORTAL_TUTORIAL_TARGETS = {
  PORTAL_NAV: 'portal-nav',
  ADD_NEW: 'add-new',
  SERVICE_MAP: 'service-map',
  GRAFTS: 'grafts',
  VISION_NAV: 'vision-nav',
  MODULES_NAV: 'modules-nav',
  GATEWAY_NAV: 'gateway-nav',
  INSIGHTS_NAV: 'insights-nav',
  ACADEMY_NAV: 'academy-nav',
} as const

export type PortalTutorialTargetId = (typeof PORTAL_TUTORIAL_TARGETS)[keyof typeof PORTAL_TUTORIAL_TARGETS]

export const PORTAL_TUTORIAL_TARGET_SELECTOR = '[data-portal-tutorial]'
